import React from 'react';
import {PortWidget} from "@projectstorm/react-diagrams";
import {map} from 'lodash';
import {showModal} from '../../../../../actions/nodeEditorPanelActions';
import {clickedNodeAction} from '../../../../../actions/clickedNodeActions';
import urlList from "../../../../../reducers/propertiesReducer";
import propertiesReducer from "../../../../../reducers/propertiesReducer";
import {connect} from "react-redux";
import axios from "axios";
import axiosConfig from "../../../../../utils/axiosConfig";
import messageCodes from "../../../../../utils/messageCodes";
import defaultOptions from '../../../../NodeEditorPanel/components/ItemOrder/defaultOptions';
import MaterialIcon from "../../../../MaterialIcon";
import {showToastForBackend, showToastForFrontend} from "../../../../../actions/toastActions";
import {ReactComponent as Fingerprint} from '../../../../../assets/icons/fingerprint.svg'
import {CustomNodeDescription} from "./CustomNodeDescription";
import {CustomNodeTitle} from "./components/CustomNodeTitle";
import popupStyles from "../../../../../utils/popupConfig";
import Popup from "reactjs-popup";
import defaultSwitchOperationOptions
    from "../../../../NodeEditorPanel/components/Predicate/const/switch/defaultSwitchOperationOptions";

class CustomNodeWidget extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            subName: "",
            logics: [],
            blockDescription: this.props.blockDescription
        };

        this.doubleClick = this.doubleClick.bind(this);
        this.getLogicList = this.getLogicList.bind(this);
        this.getCustomLogicList = this.getCustomLogicList.bind(this);
        this.getPredictorName = this.getPredictorName.bind(this);
        this.setupSorter = this.setupSorter.bind(this);
        this.updateLogics = this.updateLogics.bind(this);
        this.getLogicsList = this.getLogicsList.bind(this);
        this.prepareNode = this.prepareNode.bind(this);

    }

    updateLogics = (node) => {
        try {
            this.prepareNode(node);
        } catch (err) {
            if (err.response) {
                showToastForBackend(err.response.data);
            } else {
                showToastForFrontend(messageCodes.CONNECTION_ERROR);
            }
        }
    };

    getLogicsList(logicUrl) {
        return axios.get(logicUrl, axiosConfig())
            .then((response) => {
                return response.data
                    .filter(logic => logic.id !== +window.location.href.split("/").slice(-1))
                    .sort((a, b) => a.name > b.name ? 1 : -1);
            })
            .catch((err) => {
                // TODO handle
            });
    }

    prepareNode = async (node) => {
        const urls = propertiesReducer()
        if (!node.blockDescription) {
            node.blockDescription = {}
        }
        if (node.extras.type === 'component') {
            const logicList = await this.getLogicsList(urls.logicUrl);
            if (logicList) {
                this.setState(() => ({
                    logics: logicList
                }))
                const logicId = node?.extras?.options?.chosenLogic ?? "";
                node.blockDescription["Scenario"] =
                    logicList.find(logic => logic.id.toString() === logicId?.toString())?.name ?? "Not selected";
                this.setState(
                    {
                        blockDescription: node.blockDescription
                    })
            }
        } else {
            let requestBody = {
                options: JSON.stringify(this.props.node.extras.options),
                data: JSON.stringify(node.data),
                type: this.props.node.extras.type
            }

            let blockDescriptionUpdate =
                await axios.post(urls.logicUrl + "/blockDescription", requestBody, axiosConfig())
                    .then((response) => {
                        return response.data
                    })
                    .catch((err) => {
                        console.log(err)
                        // TODO handle
                    })

            this.setState(
                {
                    blockDescription: blockDescriptionUpdate
                }
            )
        }
    }

    componentDidMount() {
        let changedMark;
        if (this.props.node &&
            this.props.node.extras &&
            this.props.node.extras.options &&
            this.props.node.extras.options.changedMark !== undefined
        ) {
            changedMark = this.props.node.extras.options.changedMark;
        }

        if (this.props.node
            && this.props.node.extras
            && this.props.node.extras.type === "switch"
            && this.props.node.extras.options
            && this.props.node.extras.options.inputPortData
        ) {
            const inputPortData = this.props.node.extras.options.inputPortData;
            inputPortData.forEach(port => {
                port.predicate.predicates.forEach(predicate => {
                    const options = Object.keys(predicate).filter(name => name.includes("Options"));
                    options.forEach(option => {
                        if (predicate[option]) {
                            const fields = Object.keys(predicate[option]).filter(name => name.includes("Type"));
                            fields.forEach(field => {
                                if (["itemProperty", "itemId", "dynamicProperty"].indexOf(predicate[option][field]) !== -1) {
                                    const name = field.substring(0, field.indexOf("Type"));
                                    const type = option.substring(0, option.indexOf("Options"));
                                    predicate[option][field] = defaultSwitchOperationOptions[type][option][field];
                                    predicate[option][name + "Value"] = defaultSwitchOperationOptions[type][option][name + "Value"];
                                    changedMark = false;
                                }
                            })
                        }
                    })
                })
            })
        }

        this.setState({
            changedMark: changedMark
        })

        if (this.props.node
            && this.props.node.extras
            && this.props.node.extras.type === "component"
            && this.props.node.extras.options
            && this.props.node.extras.options.chosenLogic
        ) {
            this.setState({
                chosenLogic: this.props.node.extras.options.chosenLogic,
            }, () => this.getLogicList());
        }

        if (this.props.node
            && this.props.node.extras
            && this.props.node.extras.type === "predictor_first_block"
            && this.props.node.extras.options
            && this.props.node.extras.options.predictorFirstBlockOptions
        ) {
            this.setState({
                predictorFirstBlockOptions: this.props.node.extras.options.predictorFirstBlockOptions,
            }, () => this.getPredictorName());
        }

        if (this.props.node
            && this.props.node.extras
            && this.props.node.extras.type === "sorter_only"
            && this.props.node.extras.options
            && this.props.node.extras.options.sorterOptions
        ) {
            this.setState({
                sorterOptions: this.props.node.extras.options.sorterOptions,
            }, () => this.setupSorter());
        }
    }


    // eslint-disable-next-line no-unused-vars
    componentDidUpdate(_prevProps) {
        if (this.props.node &&
            this.props.node.extras &&
            this.props.node.extras.options &&
            this.props.node.extras.options.changedMark !== undefined
        ) {
            if (this.state.changedMark !== this.props.node.extras.options.changedMark) {
                this.setState({
                    changedMark: this.props.node.extras.options.changedMark
                })
            }
        }

        if (this.props.node
            && this.props.node.extras
            && this.props.node.extras.type === "component"
            && this.props.node.extras.options
            && this.props.node.extras.options.chosenLogic
        ) {
            if (this.state.chosenLogic !== this.props.node.extras.options.chosenLogic) {
                this.setState({
                    chosenLogic: this.props.node.extras.options.chosenLogic,
                }, () => this.getLogicList());
            }
        }

        if (this.props.node
            && this.props.node.extras
            && this.props.node.extras.type === "predictor_first_block"
            && this.props.node.extras.options
            && this.props.node.extras.options.predictorFirstBlockOptions
        ) {
            if (this.state.predictorFirstBlockOptions !== this.props.node.extras.options.predictorFirstBlockOptions) {
                this.setState({
                    predictorFirstBlockOptions: this.props.node.extras.options.predictorFirstBlockOptions,
                }, () => this.getPredictorName());
            }
        }

        if (this.props.node
            && this.props.node.extras
            && this.props.node.extras.type === "sorter_only"
            && this.props.node.extras.options
            && this.props.node.extras.options.sorterOptions
        ) {
            if (this.state.sorterOptions !== this.props.node.extras.options.sorterOptions)
            this.setState({
                sorterOptions: this.props.node.extras.options.sorterOptions,
            }, () => this.setupSorter());
        }

        if (_prevProps.node.extras !== this.props.node.extras) {
             this.updateLogics(this.props.node);
         }
    }

    generatePort(port) {
        let portClassName = 'srd-default-port ' + (port.connection ? 'connected' : '');

        if (port.debugInfo) {
            let portDebugInfo = port.debugInfo.itemsCount !== undefined ? port.debugInfo.itemsCount : '';

            if (port.debugInfo.extraInfo) {
                return <Popup
                    className="extra-info-popup"
                    contentStyle={popupStyles.contentStyle}
                    arrowStyle={popupStyles.arrowStyle}
                    trigger={
                    <div className={portClassName}>
                        <PortWidget port={port} key={port.getOptions().id} engine={this.props.engine}>
                            <div className='srd-debug-port'>
                                {portDebugInfo}
                            </div>
                        </PortWidget>;
                    </div>
                    }
                    position="bottom center"
                    on="hover">
                    <div className="extra-info-text">{port.debugInfo.extraInfo}</div>
                </Popup>

            }
            return <PortWidget className={portClassName} port={port} key={port.getOptions().id} engine={this.props.engine}>
                <div className='srd-debug-port'>
                    {portDebugInfo}
                </div>
            </PortWidget>;
        }

        return <PortWidget className={portClassName} port={port} key={port.getOptions().id} engine={this.props.engine}>
            <div className='srd-port'/>
        </PortWidget>
    }
    doubleClick(){
        this.props.showModal(this.props.node);
        this.props.clickedNodeAction(this.props.node);
    }

    getLogicList() {
        if (Array.isArray(this.props.logicsList)) {
            let filterdlogics = this.props.logicsList.filter(logic => logic.id === this.props.node.extras.options.chosenLogic)
            if (filterdlogics.length > 0) {
                this.setState({
                    subName: filterdlogics[0].name
                });
            }
        }
    }

    getCustomLogicList() {
        axios.get(urlList().logicUrl + "/custom", axiosConfig())
            .then((response) => {
                if (response.data.length > 0) {
                    this.setState({
                        subName: response.data[0]
                    });
                }
            })
            .catch((err) => {
                if (err.response) {
                    this.props.showToastForBackend(err.response.data);
                } else {
                    this.props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
                }
            });
    }

    getPredictorName() {
        let config = axiosConfig();
        config["params"] = {firstBlock: true};
        axios.get(urlList().logicUrl + "/predictors", config)
            .then((response) => {
                let filteredPredictors = response.data.filter(predictor => predictor.predictorName == this.props.node.extras.options.predictorFirstBlockOptions.predictorName)
                if (filteredPredictors.length > 0) {
                    this.setState({
                        subName: filteredPredictors[0].readableName
                    })
                }
            })
    }

    setupSorter() {
       let order =<><br/>{defaultOptions.itemOrders.find(a => a.value === this.state.sorterOptions.order).label}</>;
        if (this.state.sorterOptions.order === "dynamicProperty") {
            order = <><br/>{this.state.sorterOptions.dynamicSorterProperties ?
                defaultOptions.orderOptions.find(a => a.value === this.state.sorterOptions.dynamicSorterProperties[0].orderAscending).label :
                defaultOptions.orderOptions.find(a => a.value === this.state.sorterOptions.orderAscending).label}</>;
        }
        const limit = this.state.sorterOptions.isMaxResultsSelected ? <><br/>{"Limit: " + this.state.sorterOptions.maxResults}</> : ''
        this.setState({
            subName: order,
        });
    }


    render() {
        return (
			<div className={`custom-node ${this.props.node.sectionType} ${this.props.node.nodeName} ${this.props.node.isSelected()?'selected':''}`}
                onDoubleClick={() => this.doubleClick()}>
				{
					this.props.node.nodeName === 'output'
						?
						<svg className="flagged-icon">
							<path d="M0 0h24v24H0z" fill="none"></path>
							<path d="M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"></path>
						</svg>
						: ''
				}

                <CustomNodeTitle node={this.props.node}
                                 markAsUnused={this.props.node.extras.markAsUnused}
                />
                <div className={"srd-default-node__ports"}>
                    {
                        this.props.node.nodeName === 'output' ?
                            <div className="port-main">
                                <Fingerprint />
                            </div> : ''
                    }
                    <div className={"srd-default-node__in"}>
                        {map(this.props.node.getInPorts(), this.generatePort.bind(this))}
                    </div>
                    <CustomNodeDescription node={this.props.node} updateBlockDescription={this.updateLogics}
                                           state={this.state}/>
                    <div className={"node-mark"}>
                        { this.state.changedMark === false && !['no_items', 'input_items'].includes(this.props.node.nodeName) ?
                            <MaterialIcon icon="warning_amber"/> : ''
                        }
                    </div>
                    <div className={"srd-default-node__out"}>
                        {map(this.props.node.getOutPorts(), this.generatePort.bind(this))}
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        logicsList: Object.values(state.logicsList),
        clickedNodeInfo: state.clickedNodeInfo
    }
}

export default connect(mapStateToProps, {showModal, clickedNodeAction, showToastForBackend}, null)(CustomNodeWidget);
